import axios from 'axios';
import appConfig from '../config';

const apiClient = axios.create({
  baseURL: appConfig.baseURL,
  timeout: appConfig.apiTimeout,
});

// Add a request interceptor to automatically attach the token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to auto-logout blocked managers/affiliates
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      error.response?.data?.reason === 'account_blocked'
    ) {
      // Clear session and redirect to login
      localStorage.clear();
      window.location.href = '/login?reason=blocked';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
